import React from "react";
import { Link } from "react-router-dom";
import hotelConfig from "../lib/hotel.config";
import "./navigation.css";

const Navigation = ({ lang = "id", setLang }) => {
  const navLinks = {
    id: ["Beranda", "Kamar", "Fasilitas", "Galeri", "Kontak"],
    en: ["Home", "Rooms", "Facilities", "Gallery", "Contact"],
  };

  const anchors = ["#home", "#rooms", "#facilities", "#gallery", "#contact"];

  const handleNavClick = (e, sectionId) => {
    e.preventDefault();
    if (window.location.pathname === "/") {
      const el = document.getElementById(sectionId);
      if (el) el.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = "/#" + sectionId;
    }
  };

  const handleLangChange = (newLang) => {
    if (setLang) setLang(newLang);
    const overlay = document.getElementById("mobileOverlay");
    if (overlay) overlay.classList.remove("active");
    document.body.style.overflow = "";
  };

  const toggleMobile = () => {
    const overlay = document.getElementById("mobileOverlay");
    if (overlay) {
      overlay.classList.add("active");
      document.body.style.overflow = "hidden";
    }
  };

  const closeMobile = () => {
    const overlay = document.getElementById("mobileOverlay");
    if (overlay) overlay.classList.remove("active");
    document.body.style.overflow = "";
  };

  return (
    <div className="navigation-container1">
      <nav className="navigation-root">
        <div className="navigation-container">
          {/* Brand dengan Logo */}
          <div className="navigation-brand-wrapper">
            <Link to="/" style={{ textDecoration: "none" }}>
              <div
                className="navigation-logo-link"
                style={{ display: "flex", alignItems: "center", gap: "12px" }}
              >
                {/* Logo placeholder — ganti src dengan URL logo asli nanti */}
                {hotelConfig.logo_url ? (
                  <img
                    src={hotelConfig.logo_url}
                    alt="Logo"
                    style={{
                      width: "48px",
                      height: "48px",
                      objectFit: "contain",
                      borderRadius: "8px",
                    }}
                  />
                ) : (
                  <div
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "8px",
                      backgroundColor: "#0D8E8C",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "white",
                      fontWeight: "900",
                      fontSize: "20px",
                      fontFamily: "Playfair Display, serif",
                      flexShrink: 0,
                    }}
                  >
                    G
                  </div>
                )}
                <div className="navigation-logo-content">
                  <span className="navigation-brand-name">
                    {hotelConfig.nama}
                  </span>
                  <span className="navigation-brand-location">
                    {hotelConfig.kota}, {hotelConfig.negara}
                  </span>
                </div>
              </div>
            </Link>
          </div>

          {/* Desktop Menu */}
          <div className="navigation-desktop-menu">
            <ul className="navigation-links-list">
              {navLinks[lang].map((label, i) => (
                <li key={i} className="navigation-item">
                  <a
                    href={anchors[i]}
                    style={{ textDecoration: "none" }}
                    onClick={(e) =>
                      handleNavClick(e, anchors[i].replace("#", ""))
                    }
                  >
                    <div className="navigation-link">
                      <span>{label}</span>
                    </div>
                  </a>
                </li>
              ))}
            </ul>

            <div className="navigation-actions">
              <button
                onClick={() => handleLangChange(lang === "id" ? "en" : "id")}
                className="navigation-lang-toggle"
                title={
                  lang === "id" ? "Switch to English" : "Ganti ke Indonesia"
                }
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle r="10" cx="12" cy="12" />
                  <path d="M12 2a14.5 14.5 0 0 0 0 20a14.5 14.5 0 0 0 0-20M2 12h20" />
                </svg>
                <span className="navigation-thq-navigation-lang-text-elm">
                  {lang === "id" ? "🇮🇩 ID" : "🇬🇧 EN"}
                </span>
              </button>
            </div>
          </div>

          {/* Mobile Hamburger */}
          <button
            aria-label="Open Menu"
            className="navigation-mobile-toggle"
            onClick={toggleMobile}
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          </button>
        </div>
      </nav>

      {/* Mobile Overlay */}
      <div id="mobileOverlay" className="navigation-mobile-overlay">
        <div className="navigation-mobile-header">
          <div className="navigation-brand-wrapper">
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <div
                style={{
                  width: "36px",
                  height: "36px",
                  borderRadius: "6px",
                  backgroundColor: "#0D8E8C",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "white",
                  fontWeight: "900",
                  fontSize: "16px",
                }}
              >
                G
              </div>
              <span className="navigation-brand-name">{hotelConfig.nama}</span>
            </div>
          </div>
          <button
            aria-label="Close Menu"
            className="navigation-mobile-close"
            onClick={closeMobile}
          >
            <svg
              width="28"
              height="28"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="navigation-mobile-content">
          <ul className="navigation-mobile-links">
            {navLinks[lang].map((label, i) => (
              <li key={i} className="navigation-mobile-item">
                <a
                  href={anchors[i]}
                  style={{ textDecoration: "none" }}
                  onClick={(e) => {
                    closeMobile();
                    handleNavClick(e, anchors[i].replace("#", ""));
                  }}
                >
                  <div className="navigation-mobile-link">
                    <span>{label}</span>
                  </div>
                </a>
              </li>
            ))}
          </ul>

          <div className="navigation-mobile-footer">
            <div className="navigation-mobile-lang">
              <span className="navigation-mobile-label">
                {lang === "id" ? "Bahasa" : "Language"}
              </span>
              <div className="navigation-mobile-lang-grid">
                <button
                  className={`navigation-lang-btn${lang === "id" ? " active" : ""}`}
                  onClick={() => handleLangChange("id")}
                >
                  🇮🇩 Indonesia
                </button>
                <button
                  className={`navigation-lang-btn${lang === "en" ? " active" : ""}`}
                  onClick={() => handleLangChange("en")}
                >
                  🇬🇧 English
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
